import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import { makeStyles } from "@material-ui/core/styles";

import { getNotificationMessageLocale } from "../../../utils"

import './index.css'

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const useStyles = makeStyles(theme => ({
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
}));

function MySnackbarContentWrapper(props) {
  const classes = useStyles();
  const { className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={clsx(variant, className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={clsx(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="close"
          color="inherit"
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
}

MySnackbarContentWrapper.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["error", "info", "success", "warning"]).isRequired
};

export default class CustomizedSnackbars extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true
    }
  }

  getNotificationMessageLocale = () => {
    const { notification: { message }, t } = this.props
    const localizedMessage = getNotificationMessageLocale(message)
    const { content, notFoundLocale } = localizedMessage

    if (notFoundLocale) {
      return content
    } else {
      return t(content)
    }
  }

  clearNotification = () => {
    const { clearNotification } = this.props
    clearNotification()
    this.setState({ open: false })
  }

  render() {
    const { /* t, */ notification: { severity }, isLoggedIn } = this.props;
    const { open } = this.state;

    return (
      <>
        <Snackbar
          open={open}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          autoHideDuration={4000}
          onClose={this.clearNotification}
          style={{ marginTop: !isLoggedIn ? 0 : 120 }}
        >
          <MySnackbarContentWrapper
            variant={severity}
            message={this.getNotificationMessageLocale()}
            onClose={this.clearNotification}
          />
        </Snackbar>
      </>
    );
  }
}
